import ExcelJS from "exceljs";

function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

/**
 * @param {any[][]} aoaData - array of arrays (rows)
 * @param {string} sheetName
 * @param {string} filename
 * @param {{ columnWidths?: {wch: number}[], merges?: {s:{r:number,c:number}, e:{r:number,c:number}}[] }} options
 */
export async function writeAoaToFile(aoaData, sheetName, filename, options = {}) {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(sheetName);

  aoaData.forEach((row) => worksheet.addRow(row));

  if (options.columnWidths) {
    options.columnWidths.forEach((w, i) => {
      worksheet.getColumn(i + 1).width = w.wch;
    });
  }

  if (options.merges) {
    options.merges.forEach(({ s, e }) => {
      worksheet.mergeCells(s.r + 1, s.c + 1, e.r + 1, e.c + 1);
    });
  }

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  downloadBlob(blob, filename);
}
